<template>
  <div class="adp-competences">
    <div class="competence-header">
      <button class="btn adp-btn mr-4" @click="addNewGroup()">{{ $t('admin.new_group') }}</button>
      <div class="d-flex align-items-center ml-4" :class="{'catalog-switched': isInactiveItemsHidden}">
        <p class="mb-0 mr-3 catalog-switch-text">{{ $t('admin.hide_inactive') }}</p>
        <b-form-checkbox style="margin-bottom: 7px" switch size="lg" @change="hideInactiveItems()"/>
      </div>
    </div>

    <div class="tree-block" v-if="!loading">
      <sl-vue-tree v-model="competenciesTree" ref="tree">
        <template slot="title" slot-scope="{ node }">
          <span class="adp-p adp-tree" :class="{'adp-p__grey': node.data.is_hidden}">
            <img src="/images/eye_disabled.svg" alt="" v-if="node.data.is_hidden">
            {{ node.title }}
          </span>
          <img src="/images/vertical_dots.svg" alt="" class="adp-competence-kebab" @click="openCM($event, node)" ref="kebab">
        </template>
      </sl-vue-tree>

      <div class="adp-task--crud-actions" :style="cmStyles" v-if="isContextMenuVisible" v-click-outside="() => hideCM()">
        <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="hideAndShow(1);"
             v-if="!activeNode.data.is_hidden">
          {{ $t('admin.hide') }}
        </div>
        <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="hideAndShow(0);"
             v-if="activeNode.data.is_hidden">
          {{ $t('admin.show') }}
        </div>
        <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="addNewItem()"
             v-if="activeNode.data.type !== 'competence'">
          {{ addItem }}
        </div>
        <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="renameItem()">
          {{ $t('admin.rename') }}
        </div>
        <div class="btn adp-btn adp-btn__t-left adp-btn__light" @click="deleteItem();"
             v-if="activeNode.data.can_be_deleted">
          {{ $t('admin.delete') }}
        </div>
      </div>

      <!-- Modals -->
      <rename-tree-item-modal :tree-item="activeNode" @item-renamed="itemRenamed" />
      <add-new-tree-item-modal :parent="activeNode" @item-created="newItemCreated" />
    </div>
  </div>
</template>

<script>
import api from '../api';
import slVueTree from 'sl-vue-tree';
import RenameTreeItemModal from "./admin/RenameTreeItemModal";
import AddNewTreeItemModal from "./admin/AddNewTreeItemModal";

export default {
  name: "Competences",
  components: {
    'add-new-tree-item-modal': AddNewTreeItemModal,
    'rename-tree-item-modal': RenameTreeItemModal,
    'sl-vue-tree': slVueTree
  },
  data: function () {
    return {
      competenciesTree: [],
      localSavedTree: [],
      activeNode: {},
      loading: false,
      isContextMenuVisible: false,
      isInactiveItemsHidden: false,
      cmTop: 0,
      cmLeft: 0,
    }
  },
  computed: {
    cmStyles() {
      return {
        top: `${this.cmTop}px`,
        left: `${this.cmLeft}px`,
        right: 'unset',
      };
    },
    addItem() {
      if (this.activeNode.data.type === 'group') return this.$t('admin.add_competence');
    }
  },
  methods: {
    async hideInactiveItems() {
      this.isInactiveItemsHidden = !this.isInactiveItemsHidden;
      if (this.isInactiveItemsHidden) {
        this.loading = true;
        const resp = await api.getCompetencesForAdmin(true);
        this.competenciesTree = Object.values(resp.data.groups);
        this.loading = false;
      } else {
        await this.getTree();
      }
    },

    async getTree() {
      const resp = await api.getCompetencesForAdmin(false);
      this.competenciesTree = Object.values(resp.data.groups);
    },
    patchLocalTree(node, isHidden) {
      this.$refs.tree.updateNode(node.path, {title: node.title, data: { ...node.data, is_hidden: isHidden}});
      if (node.children && node.children.length) this.patchTreeChildren(node.children, isHidden);
    },
    patchTreeChildren(children, isHidden) {
      children.map(item => {
        this.$refs.tree.updateNode(item.path, {title: item.title, data: { ...item.data, is_hidden: isHidden}});
        if (item.children && item.children.length) this.patchTreeChildren(item.children, isHidden);
      })
    },
    async openCM(event, node) {
      this.cmLeft = event.pageX;
      this.cmTop = event.pageY;

      this.isContextMenuVisible = true;
      this.activeNode = node;
    },
    async reloadTree() {
      this.isContextMenuVisible = false;
      await this.getTree();
      this.$nextTick(() => this.competenciesTree = this.localSavedTree);
    },
    hideCM() {
      this.isContextMenuVisible = false;
    },
    async hideAndShow(isHidden) {
      const id = this.activeNode.data.id;

      if (isHidden === 1) await api.hideCompetence(id);
      if (isHidden === 0) await api.showCompetence(id);

      await this.patchLocalTree(this.activeNode, isHidden);
      this.localSavedTree = [...this.competenciesTree];
      await this.reloadTree();
    },
    async deleteItem() {
      const paths = this.$refs.tree.getSelected().map(node => node.path);
      this.$refs.tree.remove(paths);

      const type = this.activeNode.data.type;
      const id = this.activeNode.data.id;
      if (type === 'group') await api.deleteCompetence(id);
      if (type === 'competence') await api.deleteCompetence(id);

      this.localSavedTree = [...this.competenciesTree];
      await this.reloadTree();
    },
    renameItem() {
      this.$bvModal.show('rename-tree-item-modal');
    },
    async itemRenamed(updatedNode, oldNode) {
      this.$bvModal.hide('rename-tree-item-modal');

      this.$refs.tree.updateNode(this.activeNode.path,
        {title: updatedNode.name_ru, data: {...oldNode.data, name_en: updatedNode.name_en, name_fr: updatedNode.name_fr}});

      this.localSavedTree = [...this.competenciesTree];
      await this.reloadTree();
    },
    addNewGroup() {
      this.activeNode = {};
      this.addNewItem();
    },
    addNewItem() {
      this.$bvModal.show('add-new-tree-item-modal');
    },
    async newItemCreated(newNodeData, parentNode) {
      this.$bvModal.hide('add-new-tree-item-modal');

      if (parentNode) {
        this.$refs.tree.updateNode(parentNode.path,
          {
            title: parentNode.title,
            children: [
              ...parentNode.children,
              {title: newNodeData.name_ru, isDraggable: false, isLeaf: true,
                data: {...newNodeData, can_be_deleted: true, is_hidden: false}}
            ]
          }
        );
      } else {
        const newGroup = {title: newNodeData.name_ru, isDraggable: false,
          data: {...newNodeData, can_be_deleted: true, is_hidden: false}};
        this.competenciesTree.push(newGroup);
      }

      this.localSavedTree = [...this.competenciesTree];
      await this.reloadTree();
    },
  },
  async mounted() {
    await this.getTree();
  },
}
</script>

<style>
.adp-competences {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  padding: 20px;
}

.sl-vue-tree {
  position: relative;
  cursor: default;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
  width: fit-content;
}

.sl-vue-tree-root > .sl-vue-tree-nodes-list {
  overflow: hidden;
  position: relative;
  padding-bottom: 4px;
}

.sl-vue-tree-selected > .sl-vue-tree-node-item {
  /*background-color: rgba(100, 100, 255, 0.5);*/
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 2px;
}

.sl-vue-tree-node-list {
  position: relative;
  display: flex;
  flex-direction: row;
}

.sl-vue-tree-node-item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 34px;
  padding: 0 4px;
}

.sl-vue-tree-node-item.sl-vue-tree-cursor-inside {
  outline: 4px solid rgba(100, 100, 255, 0.5);
}

.sl-vue-tree-gap {
  width: 20px;
  min-height: 1px;

}

.sl-vue-tree-sidebar {
  margin-left: auto;
}

.sl-vue-tree-cursor {
  position: absolute;
  border: 1px solid rgba(100, 100, 255, 0.5);
  height: 1px;
  width: 100%;
}

.sl-vue-tree-drag-info {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0.5;
  margin-left: 20px;
  margin-bottom: 20px;
  padding: 5px 10px;
}

.sl-vue-tree-node-item:hover .adp-competence-kebab {
  visibility: visible;
}

.adp-competence-kebab {
  padding: 2px 12px;
  cursor: pointer;
  display: inline;
  visibility: hidden;
  order: -1;
}

.adp-tree {
  float: left;
  margin-top: 5px;
}

.sl-vue-tree-toggle {
  font-weight: bold;
  font-size: 20px;
  margin-left: 22px;
  margin-right: 5px;
}

.competence-header {
  display: flex;
  border-bottom: 1px solid #CCCCCC;
  margin: 0 -20px;
  padding: 0 17px 13px;
}

.tree-block {
  margin: 40px 30px;
}

.sl-vue-tree-title {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
}
</style>
